import { apiRequest, socialApiRequest, getCommonHeaders } from './apiWrapper'
import { assetApi, userAppApi, voiceRemixApi, apiGatewayUrl } from '../utils/axiosInstance'
import { isGatePublishEnabled } from '../utils/localStorage'

export { isGatePublishEnabled }

export const publishFaceSwapImage = async (data) => {
    let payload = data
    if (data instanceof FormData) {
        payload = {}
        data.forEach((value, key) => {
            if (typeof value === 'string' && (value.startsWith('[') || value.startsWith('{'))) {
                try {
                    payload[key] = JSON.parse(value)
                    return
                } catch (e) {}
            }
            payload[key] = value
        })
    }
    const response = await socialApiRequest({
        method: 'post',
        url: 'publish',
        data: payload
    })
    return response
}

export async function postFeedback(
    content_id,
    feedback_type,
    feedback_comment
) {
    return apiRequest({
        method: 'post',
        url: '/content_feedback/',
        data: { content_id, feedback_type, feedback_comment }
    })
}

export async function postChatFeedback(
    content_id,
    feedback_type,
    feedback_comment
) {

    return apiRequest({
        method: 'post',
        url: 'aiproxy/v1/llm/chat_llm/content_feedback',
        data: { content_id, feedback_type, feedback_comment },
        headers: {
            ...getCommonHeaders()
        }
    })
}

export const editpublishFaceSwapImage = async (data, content_id) => {
    let payload = data
    if (data instanceof FormData) {
        payload = {}
        data.forEach((value, key) => {
            if (typeof value === 'string' && (value.startsWith('[') || value.startsWith('{'))) {
                try {
                    payload[key] = JSON.parse(value)
                    return
                } catch (e) {}
            }
            payload[key] = value
        })
    }
    const response = await socialApiRequest({
        method: 'patch',
        url: `publish/${content_id}`,
        data: payload
    })
    return response
}

export async function deletePublishImage(content_id) {
    const response = await socialApiRequest({
        method: 'delete',
        url: `publish/${content_id}`
    })
    return response
}

export { deleteContentItems } from './profilePageApi'

export const makeContentPrivate = async (content_id) => {
    const formData = new FormData()
    formData.append('content_id', content_id)
    const response = await apiRequest({
        method: 'post',
        url: 'makeprivate/',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return response
}

export const uploadEditSuiteAsset = async (formData) => {
    const response = await assetApi.post('asset-manager/edit-suite/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return response.data
}

export const uploadThumbnailImage = async (formData) => {
    const response = await assetApi.post('asset-manager/thumbnail', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return response.data
}

export const gatePublish = async (formData) => {
    if (!isGatePublishEnabled()) {
        return { decision: 'accepted', status: 'skipped', bypassed: true };
    }
    const userId = JSON.parse(localStorage.getItem('user'))?.user_id || "";

    const response = await apiGatewayUrl.post('/aitools/audible/v1/gate/publish', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'X-User-Id': userId,
            'X-Country': 'IN'
        }
    })
    return response.data
}

export const gatePublishWithStream = async (formData) => {
    if (!isGatePublishEnabled()) {
        return { decision: 'accepted', status: 'skipped', bypassed: true };
    }
    const userId = JSON.parse(localStorage.getItem('user'))?.user_id || "";

    const response = await apiGatewayUrl.post('/aitools/audible/v1/gate/publish', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'X-User-Id': userId,
            'X-Country': 'IN'
        }
    })
    
    const data = response.data;
    if (!data || !data.event_id) {
        throw new Error("No event_id returned from publish");
    }

    const eventId = data.event_id;
    const baseUrl = apiGatewayUrl.defaults.baseURL || process.env.REACT_APP_API_GATEWAY_BASE_URL || 'https://eu-dev-apigateway.erosuniverse.com/';
    const streamUrl = `${baseUrl.replace(/\/$/, '')}/aitools/audible/v1/gate/publish/stream/${eventId}`;
    
    return new Promise(async (resolve, reject) => {
        let retries = 10; // Allow up to 10 reconnects in case the server drops idle connections
        let isDone = false;

        while (retries > 0 && !isDone) {
            try {
                const accessToken = localStorage.getItem('access') || '';
                const headers = {
                    'X-User-Id': userId,
                    'X-Country': 'IN',
                    'Accept': 'text/event-stream'
                };
                if (accessToken) {
                    headers['Authorization'] = `Bearer ${accessToken}`;
                    headers['x-api-token'] = accessToken;
                }

                const streamResponse = await fetch(streamUrl, {
                    headers
                });

                if (!streamResponse.ok) {
                    throw new Error(`Failed to connect to stream: ${streamResponse.status}`);
                }

                const reader = streamResponse.body.getReader();
                const decoder = new TextDecoder('utf-8');
                let buffer = '';

                while (true) {
                    const { done, value } = await reader.read();
                    if (done) {
                        if (buffer.trim()) {
                            try {
                                const rawData = JSON.parse(buffer);
                                const detail = rawData.detail || rawData;
                                if (rawData.stage === 'done' || detail.decision || detail.status === 'completed' || detail.status === 'published' || detail.status === 'success') {
                                    isDone = true;
                                    resolve(detail);
                                    return;
                                } else if (rawData.stage === 'error' || detail.status === 'failed' || detail.status === 'error') {
                                    isDone = true;
                                    reject(new Error(detail.message || "Validation failed"));
                                    return;
                                }
                            } catch (e) {
                                const lines = buffer.split(/\r?\n/);
                                for (const line of lines) {
                                    if (line.trim().startsWith('data:')) {
                                        try {
                                            const dataStr = line.replace('data:', '').trim();
                                            if (!dataStr) continue;
                                            const streamData = JSON.parse(dataStr);
                                            const detail = streamData.detail || streamData;
                                            if (streamData.stage === 'done' || detail.decision || detail.status === 'completed' || detail.status === 'published' || detail.status === 'success') {
                                                isDone = true;
                                                resolve(detail);
                                                return;
                                            } else if (streamData.stage === 'error' || detail.status === 'failed' || detail.status === 'error') {
                                                isDone = true;
                                                reject(new Error(detail.message || "Validation failed"));
                                                return;
                                            }
                                        } catch (err) {}
                                    }
                                }
                            }
                        }
                        break; // Connection closed (e.g., API Gateway timeout). Will reconnect if not finished.
                    }
                    
                    buffer += decoder.decode(value, { stream: true });
                    
                    // Fallback: Check if the server is sending raw JSON instead of SSE
                    try {
                        const rawData = JSON.parse(buffer);
                        const detail = rawData.detail || rawData;
                        if (rawData.stage === 'done' || detail.decision || detail.status === 'completed' || detail.status === 'published' || detail.status === 'success') {
                            isDone = true;
                            resolve(detail);
                            return;
                        } else if (rawData.stage === 'error' || detail.status === 'failed' || detail.status === 'error') {
                            isDone = true;
                            reject(new Error(detail.message || "Validation failed"));
                            return;
                        }
                    } catch(e) {}
                    
                    // Process as standard SSE
                    const parts = buffer.split(/\r?\n\r?\n/);
                    buffer = parts.pop();
                    
                    for (const part of parts) {
                        const lines = part.split(/\r?\n/);
                        for (const line of lines) {
                            if (line.trim().startsWith('data:')) {
                                try {
                                    const dataStr = line.replace('data:', '').trim();
                                    if (!dataStr) continue;
                                    const streamData = JSON.parse(dataStr);
                                    
                                    const detail = streamData.detail || streamData;
                                    if (streamData.stage === 'done' || detail.decision || detail.status === 'completed' || detail.status === 'published' || detail.status === 'success') {
                                        isDone = true;
                                        resolve(detail);
                                        return;
                                    } else if (streamData.stage === 'error' || detail.status === 'failed' || detail.status === 'error') {
                                        isDone = true;
                                        reject(new Error(detail.message || "Validation failed"));
                                        return;
                                    }
                                } catch (e) {
                                    console.error("Parse error in stream chunk", e);
                                }
                            }
                        }
                    }
                }
                
                // Connection closed cleanly but no final payload received. Wait and reconnect.
                retries--;
                if (retries > 0) {
                    await new Promise(r => setTimeout(r, 2000));
                }
            } catch (error) {
                console.error("Stream connection error, reconnecting...", error);
                retries--;
                if (retries === 0) {
                    reject(error);
                    return;
                }
                await new Promise(r => setTimeout(r, 2000));
            }
        }
        
        if (!isDone) {
            reject(new Error("Stream ended without completion after multiple retries"));
        }
    });
}

export const sendAnalyticsEvent = async (payload) => {
    if (!isGatePublishEnabled()) {
        return { success: true, status: 'skipped', bypassed: true };
    }
    const userId = JSON.parse(localStorage.getItem('user'))?.user_id || "";
    
    const response = await apiGatewayUrl.post('/aitools/music-reporting/v1/analytics/events', payload, {
        headers: {
            'Content-Type': 'application/json',
            'X-User-Id': userId,
            'X-Country': 'IN'
        }
    })
    return response.data
}
